import { useMemo } from 'react'

import { AdditionalCostTypeRestEndpointService } from '@api'
import { isBefore } from 'date-fns'
import { useQuery } from 'react-query'

import { handleError } from '@/utils/error'

export const useAccountingAdditionalCostTypes = () => {
  const { data, isLoading, error, isSuccess, isError, refetch } = useQuery({
    queryKey: ['accounting', 'additional-cost', 'types'],
    queryFn: () =>
      AdditionalCostTypeRestEndpointService.dashboardGetAdditionalCostTypes(),
    placeholderData: [],
    onError: (error) =>
      handleError(error, 'Failed to get additional cost types', refetch),
  })

  const sortedData = useMemo(() => {
    return data?.sort((a, b) => {
      if (!a?.createdAt || !b?.createdAt) return 0

      return isBefore(new Date(a.createdAt), new Date(b.createdAt)) ? 1 : -1
    })
  }, [data])

  return {
    data: sortedData ?? [],
    isLoading,
    error,
    isSuccess,
    refetch,
    isError,
  }
}
